import $http from "../../axios";
import {Notification, MessageBox} from "element-ui";
import {getApiDomain} from "../../util/domains";

export async function setPerPagePagination({commit, dispatch}, perPage) {
    commit("setPerPage", parseInt(perPage.target.value));
    dispatch("getAccountingConcepts");
}

export async function setPagePagination({commit, dispatch}, page) {
    commit("setPage", parseInt(page));
    dispatch("getAccountingConcepts");
}
export async function setFilterAction({commit, dispatch}, filter) {
    commit("setFilter", filter);
    dispatch("getAccountingConcepts");
}

export async function getAccountingConcepts({state, commit}) {
    await $http.get('/api/conceptos-contables', {params: state.params}).then(response => {
        commit('setAccountingConcepts', response.data);
    }).catch(error => {
    })
}

export async function createAccountingConcept({state, commit}) {
    $http.post('/api/conceptos-contables', state.selectedAccountingConcept).then(response => {
        commit('setSelectedAccountingConcept', response.data.data);
        Notification.success({
            title: "Exito!",
            message: "Concepto Contable Creado  Correctamente",
            type: "success",
            duration: 2000,
            customClass: "notification-box"
        });
    }).catch(error => {
        state.error = true;
        Notification.error({
            title: "error!",
            message: error.response.data.message,
            type: "error",
            duration: 2000,
            customClass: "notification-box"
        });
    })
}

export async function getAccountingConceptById({commit}, id) {
    await $http.get(`/api/conceptos-contables/${id}`).then(response => {
        commit('setSelectedAccountingConcept', response.data.data);
    }).catch(error => {
        Notification.error({
            title: "error!",
            message: error.response.data.message,
            type: "error",
            duration: 2000,
            customClass: "notification-box"
        });
    });

}

export async function updateAccountingConcept({state,commit}) {

    $http.put(`/api/conceptos-contables/${state.selectedAccountingConcept.id}`, state.selectedAccountingConcept).then(response => {
        commit('setSelectedAccountingConcept', response.data.data);
        Notification.success({
            title: "Exito!",
            message: 'Se ha Actualizado Correctamente el Concepto Contable',
            type: "success",
            duration: 2000,
            customClass: "notification-box"
        });
    }).catch(error => {
        Notification.error({
            title: "error!",
            message: error.response.data.message,
            type: "error",
            duration: 2000,
            customClass: "notification-box"
        });
    });

}

export async function createAccountingConceptTransaction({state, commit}) {

    state.selectedAccountingConceptTransaction.accounting_concept_id = state.selectedAccountingConcept.id
    $http.post(`/api/conceptos-contables/transacciones`, state.selectedAccountingConceptTransaction).then(response => {
        commit('setSelectedAccountingConcept', response.data.data);
        Notification.success({
            title: "Exito!",
            message: 'Se ha Actualizado Correctamente la transacción del  Concepto Contable',
            type: "success",
            duration: 2000,
            customClass: "notification-box"
        });
    }).catch(error => {
        state.error = true
        Notification.error({
            title: "error!",
            message: error.response.data.message,
            type: "error",
            duration: 2000,
            customClass: "notification-box"
        });
    });

}

export async function updateAccountingConceptTransaction({state, commit}) {
    $http.put(`/api/conceptos-contables/transacciones/${state.selectedAccountingConceptTransaction.id}`, state.selectedAccountingConceptTransaction).then(response => {
        commit('setSelectedAccountingConcept', response.data.data);
        Notification.success({
            title: "Exito!",
            message: 'Se ha Actualizado Correctamente la transacción del  Concepto Contable',
            type: "success",
            duration: 2000,
            customClass: "notification-box"
        });
    }).catch(error => {
        Notification.error({
            title: "error!",
            message: error.response.data.message,
            type: "error",
            duration: 2000,
            customClass: "notification-box"
        });
    });

}

export async function deleteAccountingConceptById({state,commit}, id) {
    await $http.delete(`/api/conceptos-contables/${id}`).then(response => {
        Notification.success({
            title: "Exito!",
            message: 'Se ha Eliminado Correctamente el Concepto Contable',
            type: "success",
            duration: 2000,
            customClass: "notification-box"
        });
    }).catch(error => {
        Notification.error({
            title: "error!",
            message: error.message,
            type: "error",
            duration: 2000,
            customClass: "notification-box"
        });
    });
}

export async function deleteAccountingConceptByIdTransaction({state, commit}, id) {
    await $http.delete(`/api/conceptos-contables/transacciones/${id}`).then(response => {
        commit('setSelectedAccountingConcept', response.data.data);
        Notification.success({
            title: "Exito!",
            message: 'Se ha Eliminado Correctamente el Concepto Contable',
            type: "success",
            duration: 2000,
            customClass: "notification-box"
        });
    }).catch(error => {
        Notification.error({
            title: "error!",
            message: error.response.data.message,
            type: "error",
            duration: 2000,
            customClass: "notification-box"
        });
    });
}

export async function fetchAccounts({commit, state}, text) {
    await $http
        .get("/api/cuentas-lite", {params: {filter: text}})
        .then(response => {
            commit("setAccounts", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}

export async function uploadExcel({state,dispatch}) {

    let formData = new FormData();
    formData.append('file', state.file);

    $http.post(`/api/conceptos-contables/importar`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then(response => {
        dispatch("getAccountingConcepts");
        if(response.data.url){

            Notification.error({
                title: "Error!",
                message: 'El archivo Contiene inconsistencias',
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });

            // Extraer la URL del archivo del objeto de respuesta
            const archivoUrl = response.data.url;
            // Construir la URL absoluta
            const urlCompleta = getApiDomain() + archivoUrl;
            console.log(urlCompleta)
            // Crear un enlace de descarga
            const link = document.createElement('a');
            link.href = urlCompleta;
            link.setAttribute('download', 'Conceptos_contables_error.xlsx'); // Nombre del archivo
            document.body.appendChild(link);

            // Simular un clic en el enlace para iniciar la descarga
            link.click();

        }else{
            Notification.success({
                title: "Success!",
                message: 'Archivo cargado',
                type: "success",
                duration: 3000,
                customClass: "notification-box"
            });
        }

    })
        .catch(error => {
            state.loading.module = false ;
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 3000,
                customClass: "notification-box"
            });
        });
}
export async function downloadTemplate({state},download_info = false) {
    let name = 'Conceptos_contables_template.xlsx'
    await $http({
        url: '/api/conceptos-contables-template?download_data='+download_info,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();

    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });
    })
}

/**
 * Obtener los parámetros.
 */
export async function getParameters({commit}) {
    await $http.get(`/api/parametros-por-codigo/C-015`)
        .then((response) => {
            commit('setParameters', response.data.data);
        })
        .catch((error) => {

        });
}



// WEBPACK FOOTER //
// ./src/modules/accounting_concept/actions.js